import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/Common";
import { KeyRound } from "lucide-react";

export default function PermissionsPage() {
  const { t } = useApp();
  const [catalog, setCatalog] = useState([]);
  useEffect(() => { api.get("/permissions").then((r) => setCatalog(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title={t("permissions")} subtitle="System permission catalog grouped by module" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {catalog.map((mod) => (
          <div key={mod.module} className="bg-card border border-border rounded-md p-5" data-testid={`perm-group-${mod.module}`}>
            <div className="flex items-center gap-2 mb-3">
              <div className="h-8 w-8 rounded-md bg-primary/10 text-primary flex items-center justify-center"><KeyRound className="h-4 w-4" /></div>
              <h3 className="font-heading font-semibold text-sm">{mod.label}</h3>
            </div>
            <div className="space-y-2">
              {mod.permissions.map((p) => (
                <div key={p.key} className="flex items-center justify-between text-sm border-b border-border last:border-0 pb-2 last:pb-0">
                  <span>{p.name}</span>
                  <code className="text-[10px] text-muted-foreground bg-muted px-1.5 py-0.5 rounded">{p.key}</code>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
